import { render } from "./detail.vue?vue&type=template&id=1295955c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=1295955c&lang=scss&scoped=true"
import "./detail.vue?vue&type=style&index=1&id=1295955c&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1295955c"]])

export default __exports__